import React, {useState} from 'react'
import {copyText} from '../../../../components/renders'
import {shouldDisplayFonctionnalite} from '../../../../components/helpers'
import {useAuth} from '../../../modules/auth'

interface tarifProps {
  dataPrix?: any
}

const InfoTarifications = ({dataPrix}: tarifProps) => {
  const [checkCopy, setCheckCopy] = useState<string | null>(null)
  const dataMetrique = JSON.parse(dataPrix?.metriques)
  const {currentUser} = useAuth()

  const handleCopie = (texte, e) => {
    e.stopPropagation()
    copyText(texte, setCheckCopy, 500)
  }

  return (
    <div style={{width: '45%'}}>
      <div className='d-flex gap-2'>
        <h4 className='mb-5'>Référence constructeur : {dataPrix?.refConst}</h4>
        {checkCopy !== dataPrix?.refConst ? (
          <i
            className='ki-duotone ki-copy cursor-pointer fs-2'
            onClick={(e) => handleCopie(dataPrix?.refConst, e)}
          ></i>
        ) : (
          <i className='ki-duotone ki-copy-success fs-2'>
            <span className='path1'></span>
            <span className='path2'></span>
          </i>
        )}
      </div>
      <div className='d-flex flex-column'>
        <div className={`${dataPrix?.metriques !== null ? '' : 'h-350px'}`}>
          {dataPrix?.metriques !== null && (
            <>
              <div className='d-flex gap-3'>
                <div className='table-responsive border-1 border border-secondary rounded-1 mb-3  w-50'>
                  <table className='table ow-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead>
                      <tr style={{backgroundColor: 'green', color: '#fff'}}>
                        <th>
                          <i className='bi bi-box-arrow-in-down-left text-white me-2 ms-3 fs-4'></i>
                          Jalons marchés
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Tiers 1 (bas)</td>
                        <td>
                          {dataMetrique?.prixTier1 != null
                            ? `${dataMetrique?.prixTier1.toFixed(2)} €`
                            : ''}
                        </td>
                      </tr>
                      <tr>
                        <td>Tiers 3 (haut)</td>
                        <td>
                          {dataMetrique?.prixTier3 != null
                            ? `${dataMetrique?.prixTier3.toFixed(2)} €`
                            : ''}
                        </td>
                      </tr>
                      <tr>
                        <td>Qté marché</td>
                        <td>{dataMetrique?.qteMarcheOpisto}</td>
                      </tr>
                      <tr>
                        <td
                            className='d-flex gap-2 align-items-center'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title='Prix constructeur récupéré par Koena'
                        >
                          Prix OE KOENA
                          <i className='bi bi-info-square-fill' style={{color: 'green',cursor:'pointer'}}></i>
                        </td>
                        <td>
                          {dataMetrique?.prixOeKoena != null
                            ? `${dataMetrique?.prixOeKoena.toFixed(2)} €`
                            : ''}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div className='table-responsive border-1 border border-secondary rounded-1 mb-3  w-50'>
                  <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                    <thead>
                      <tr style={{backgroundColor: 'green', color: '#fff'}}>
                        <th>
                          <i className='bi bi-joystick text-white me-2 ms-3 fs-4'></i>
                          Stock & vente
                        </th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Quantité en stock</td>
                        <td>{dataMetrique?.qteStock}</td>
                      </tr>
                      <tr>
                        <td
                            className='d-flex gap-2 align-items-center'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title='Depuis 1 an'
                        >
                          Quantité vendue
                          <i className='bi bi-info-square-fill' style={{color: 'green',cursor:'pointer'}}></i>
                        </td>
                        <td>{dataMetrique?.qteVente}</td>
                      </tr>
                      <tr>
                        <td
                            className='d-flex gap-2 align-items-center'
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title='Nombre de jour cumulé des pièces en stock'
                        >
                          Durée stockage
                          <i className='bi bi-info-square-fill' style={{color: 'green',cursor:'pointer'}}></i>
                        </td>
                        <td>{dataMetrique?.dureeStockage} j</td>
                      </tr>
                      <tr>
                        <td>Prix vente moyen</td>
                        <td>
                          {dataMetrique?.prixVenteMoyen != null
                            ? `${dataMetrique?.prixVenteMoyen.toFixed(2)} €`
                            : ''}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              {/* affichage des indices du prix par rapport au role "Visualisation des indices" */}
              {shouldDisplayFonctionnalite(currentUser, 'VOIR INDICE') && (
                <div className='d-flex gap-3'>
                  <div className='table-responsive border-1 border border-secondary rounded-1 mb-3  w-50'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead>
                        <tr style={{backgroundColor: 'green', color: '#fff'}}>
                          <th>
                            <i className='bi bi-app-indicator text-white me-2 ms-3 fs-4'></i>
                            Indices calculés
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Indice stock (mod)</td>
                          <td>{dataMetrique?.indiceStock}</td>
                        </tr>
                        <tr>
                          <td>Indice rareté (mod)</td>
                          <td>{dataMetrique?.indiceRarete}</td>
                        </tr>
                        <tr>
                          <td>Indice durée (mod)</td>
                          <td>{dataMetrique?.indiceDuree}</td>
                        </tr>
                        <tr>
                          <td>Indice global</td>
                          <td>
                            {dataMetrique?.indiceGlobal != null
                              ? `${dataMetrique?.indiceGlobal.toFixed(2)}`
                              : '0'}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div className='table-responsive border-1 border border-secondary rounded-1 mb-3  w-50'>
                    <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                      <thead>
                        <tr style={{backgroundColor: 'green', color: '#fff'}}>
                          <th>
                            <i className='bi bi-sliders2 text-white me-2 ms-3 fs-4'></i>
                            Poids sélectionné
                          </th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Poids stock</td>
                          <td>{dataMetrique?.poidsStock}</td>
                        </tr>
                        <tr>
                          <td>Poids rareté</td>
                          <td>{dataMetrique?.poidsRarete}</td>
                        </tr>
                        <tr>
                          <td>Poids durée</td>
                          <td>{dataMetrique?.poidsDuree}</td>
                        </tr>
                        <tr>
                          <td></td>
                          <td></td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
        <div className='table-responsive border-1 border border-secondary rounded-1'>
          <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
            <thead>
              <tr style={{backgroundColor: 'green', color: '#fff'}}>
                <th>
                  <i className='bi bi-layout-text-window-reverse text-white me-2 ms-3 fs-4'></i>
                  Libellé
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Référence pièce</td>
                <td>
                  <div className='d-flex gap-2'>
                    {dataPrix?.codePiece}
                    {dataPrix?.codePiece && (checkCopy !== dataPrix?.codePiece ? (
                      <i
                        className='ki-duotone ki-copy cursor-pointer fs-2'
                        onClick={(e) => handleCopie(dataPrix?.codePiece, e)}
                      ></i>
                    ) : (
                      <i className='ki-duotone ki-copy-success fs-2'>
                        <span className='path1'></span>
                        <span className='path2'></span>
                      </i>
                    ))}
                  </div>
                </td>
              </tr>
              <tr>
                <td>Libellé</td>
                <td>{dataMetrique?.libelle}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
export {InfoTarifications}
